// extracted by mini-css-extract-plugin
export var pillWrapper = "_na-0";
export var showOverflow = "_na-1";